import { Routes } from '@angular/router';
import { CarInsuranceSuccessPageComponent } from './components/car-insurance/car-insurance-success-page/car-insurance-success-page.component';
import { CarInsuranceWhytochooseComponent } from './components/car-insurance/car-insurance-whytochoose/car-insurance-whytochoose.component';
import { CarInsuranceHomeComponent } from './components/car-insurance/car-insurance-home/car-insurance-home.component';

export const carInsuranceRoutes: Routes = [
  {
    path: '',
    component: CarInsuranceHomeComponent,
    children: [
      { path: 'success', component: CarInsuranceSuccessPageComponent },
      { path: 'form', component: CarInsuranceWhytochooseComponent }
    ]
  }
];
